import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PROCESSO_STATUS_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro,
				preco: FormatUtils.formatarValorTela(registro.preco, 2)
			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('processoStatusForm', {
			...registro,
			preco: FormatUtils.formatarValorTela(registro.preco, 2)
		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'PROCESSO_STATUS_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/processoStatus`);
    return {
        type: 'PROCESSO_STATUS_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/processoStatus`, {
				...registro,
				preco: FormatUtils.formatarValorBanco(registro.preco, 2)
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/processoStatus`, {
				...registro,
				preco: FormatUtils.formatarValorBanco(registro.preco, 2)
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/processoStatus?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
